import React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "./spinner";

type TransactionActionButtonProps = {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  label?: string;
};

type Variant = "approve" | "reject";

const BASE_BUTTON_STYLE: React.CSSProperties = {
  width: 70,
  height: 32,
  marginLeft: 5,
  marginRight: 5,
};

const TransactionActionButton: React.FC<
  TransactionActionButtonProps & { variant: Variant }
> = ({
  variant,
  onClick,
  isLoading,
  disabled,
  className,
  style,
  label,
}) => {
  const { t } = useTranslation();
  const isDisabled = disabled || isLoading;
  const isApprove = variant === "approve";
  const baseClassName = isApprove
    ? isDisabled
      ? "rounded px-2 py-1 text-xs text-white bg-neutral-light pointer-events-none cursor-not-allowed flex items-center justify-center"
      : "rounded px-2 py-1 text-xs text-green-700 bg-green-100 hover:bg-green-200 transition-colors flex items-center justify-center"
    : isDisabled
      ? "rounded px-2 py-1 text-xs text-white bg-neutral-light pointer-events-none cursor-not-allowed flex items-center justify-center"
      : "rounded bg-gray-100 px-2 py-1 text-xs text-red-700 transition-colors hover:bg-gray-200 flex items-center justify-center";

  const spinnerColor = isApprove ? "#0f5132" : "#000000";
  const spinnerSecondaryColor = isApprove
    ? "rgba(15,81,50,0.2)"
    : "rgba(0,0,0,0.2)";

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={[baseClassName, className].filter(Boolean).join(" ")}
      style={{ ...BASE_BUTTON_STYLE, ...style }}
    >
      {isLoading ? (
        <Spinner
          variant="small"
          color={spinnerColor}
          secondaryColor={spinnerSecondaryColor}
        />
      ) : (
        label ||
        (isApprove
          ? t("lifestyleTransactions.actions.approve")
          : t("lifestyleTransactions.actions.reject"))
      )}
    </button>
  );
};

export const ApproveTransactionButton: React.FC<TransactionActionButtonProps> = (
  props,
) => <TransactionActionButton variant="approve" {...props} />;

export const RejectTransactionButton: React.FC<TransactionActionButtonProps> = (
  props,
) => <TransactionActionButton variant="reject" {...props} />;
